<template>
  <transition name="expand" @enter="enter" @after-enter="afterEnter" @leave="leave">
    <slot />
  </transition>
</template>

<script>
export default {
  name: 'TransitionExpand',

  props: {
    onlyMobile: {
      type: Boolean,
      required: false,
      default: false
    },

    isMobile: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  methods: {
    enter(element) {
      if (!this.onlyMobile || (this.onlyMobile && this.isMobile)) {
        element.style.height = element.scrollHeight + 'px'
        element.style.opacity = 1
      }
    },

    afterEnter(element) {
      if (!this.onlyMobile || (this.onlyMobile && this.isMobile)) {
        element.style.height = 'auto'
      }
    },

    leave(element) {
      if (!this.onlyMobile || (this.onlyMobile && this.isMobile)) {
        element.style.height = element.scrollHeight + 'px'
        setTimeout(() => {
          element.style.height = 0
          element.style.opacity = 0
        }, 50)
      }
    }
  }
}
</script>

<style scoped>
* {
  will-change: height, margin-top, margin-bottom, opacity;
  transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 1000px;
}

.expand-enter-active,
.expand-leave-active {
  transition: height 0.4s ease-in-out, margin-top 0.4s ease-in-out, margin-bottom 0.4s ease-in-out,
    opacity 0.2s ease-in-out;
  overflow: hidden;
}

.expand-enter,
.expand-leave-to {
  height: 0;
  margin-top: 0;
  margin-bottom: 0;
  opacity: 0;
}
</style>
